import React from "react";
import { ReactComponent as OverviewIcon } from "./assets/overview.svg";
import { ReactComponent as AppsIcon } from "./assets/apps.svg";
import { ReactComponent as AppInsightsIcon } from "./assets/app-insights.svg";
import { ReactComponent as BalanceIcon } from "./assets/balance.svg";
import { ReactComponent as OrdersIcon } from "./assets/orders.svg";
import { ReactComponent as PlannerIcon } from "./assets/planner.svg";
import { ReactComponent as ActivityIcon } from "./assets/activity.svg";
import { ReactComponent as NewOrderIcon } from "./assets/new-order.svg";
import { ReactComponent as ArrowLeftIcon } from "./assets/arrow-left.svg";
import { ReactComponent as LogoIcon } from "./assets/logo.svg";
import { IconName } from "./types";

/** Each nav icon carries its own tone (icon-bg color) from the Figma design. */
export const ICONS: Record<
  IconName,
  { Svg: React.FC<React.SVGProps<SVGSVGElement>>; tone: string }
> = {
  overview: { Svg: OverviewIcon, tone: "overview" },
  apps: { Svg: AppsIcon, tone: "apps" },
  "app-insights": { Svg: AppInsightsIcon, tone: "appInsights" },
  balance: { Svg: BalanceIcon, tone: "balance" },
  orders: { Svg: OrdersIcon, tone: "orders" },
  planner: { Svg: PlannerIcon, tone: "planner" },
  activity: { Svg: ActivityIcon, tone: "activity" },
  "new-order": { Svg: NewOrderIcon, tone: "overview" },
};

/** 20px cross on currentColor: closes the phone drawer. */
export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
    <path
      d="M5 5l10 10M15 5L5 15"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

/** 20px three lines on currentColor: opens the phone drawer. */
export const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
    <path
      d="M3 5h14M3 10h14M3 15h14"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export { ArrowLeftIcon, LogoIcon };
